import { Button, Box, Typography, Stack, Tooltip } from "@mui/material"
import { CustomField } from "../../../__generated__/graphql"
import { Add } from "@mui/icons-material"
import { useSlideInContext } from "../../../context/SlideInContext"
import { ADD_NEW_CUSTOMFIELD } from "../../components/SlideIn/contentTypes"
import { TableStandard, SearchBar, HeaderActionType } from "ui"
// import { TableStandard } from "../../../../components/Reusable/Tables"
import { GridColDef, GridNoRowsOverlay, GridRowModel } from "@mui/x-data-grid"
import { useEffect, useState } from "react"
import { GET_LOCATION_CUSTOMFIELDS } from "../../../features/graphql/query"
import { useQuery } from "@apollo/client"
import { useParams } from "react-router"
interface customFieldTableProps {
    customfields: CustomField[] | []
}

const CUSTOM_FIELD_COLUMNS: GridColDef[] = [
    {
        field: "name", headerName: "Field Name", flex: 1, sortable: true, disableColumnMenu: true,
    },
    {
        field: "type", headerName: "Type", flex: 1, sortable: true, disableColumnMenu: true,
    },
    {
        field: "required", headerName: "Required", flex: 1, sortable: false, disableColumnMenu: true,
        renderCell: (value) => {
            const _value = value.row.required ? "Yes" : "No"
            return (<Typography>{_value}</Typography>)
        }
    },
]
export function CustomFieldTable({ customfields }: customFieldTableProps) {
    const { handleContent, toggleDrawer } = useSlideInContext();
    const { lid } = useParams()
    const { loading, data } = useQuery(GET_LOCATION_CUSTOMFIELDS, {
        notifyOnNetworkStatusChange: true,
        variables: { locationId: lid }
    })
    const handleNewCustomField = () => {
        handleContent(ADD_NEW_CUSTOMFIELD);
        toggleDrawer()
    }
    const [pageTableState, setPageTableState] = useState<{ columns: GridColDef[], rows: GridRowModel[] }>({
        columns: [],
        rows: []
    })
    useEffect(() => {
        setPageTableState((prevState) => {
            const columns = [...CUSTOM_FIELD_COLUMNS]
            const rows = data?.customFields?.map((e: any) => e) ?? [];
            return {
                ...prevState,
                columns,
                rows
            }
        })
    }, [loading, data])

    return (
        <TableStandard
            loading={loading}
            renderToolbar={({ searchQuery, onSearch, onSearchClear }) => {
                return (
                    <Box component="div" sx={{ display: "flex", alignItems: "center" }}>
                        <Tooltip title={pageTableState?.rows.length >= 2 ? "Reached Limit" : ""}>
                            <Box component="div" sx={{ padding: "15px" }}>
                                <Button color="secondary"
                                    size="small"
                                    onClick={handleNewCustomField}
                                    disabled={pageTableState.rows.length >= 2}
                                    startIcon={<Add style={{
                                        backgroundColor: "#253D93",
                                        borderRadius: "100%",
                                        color: "white",
                                    }} />}
                                >
                                    Add New Custom Field
                                </Button>
                            </Box>
                        </Tooltip>
                    </Box >
                )
            }}
            slots={{ noRowsOverlay: (customfields.length <= 0 ? NoCustomFieldsOverlay : GridNoRowsOverlay) }}
            columns={pageTableState.columns}
            rows={pageTableState.rows}
            pageSize={2}
            disableBoxShadow={true}
        />
    )
}

function NoCustomFieldsOverlay() {
    return (
        <Stack height="100%" alignItems="center" justifyContent="center">
            <Typography>
                There are no custom fields associated with this location
            </Typography>
        </Stack>
    )
}